// extracted by mini-css-extract-plugin
module.exports = {"techSnapshot-section":"elements_techSnapshot-section__2XhZ5","techSnapshot-decorative":"elements_techSnapshot-decorative__3dMe5"};